/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Save_User_ButtonInputs */



/**
* | output |
* | --- |
* | "Save User" |
*
* @param {Team_Manager_Save_User_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_user_button = /** @type {((inputs?: Team_Manager_Save_User_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_User_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer l’utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता को सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar usuário")
	return /** @type {LocalizedString} */ ("Save User")
});